/**
 * @returns {boolean} True if user prefers reduced motion
 */
const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Animate a cart item row collapsing to zero height, then remove it.
 * Uses the Web Animations API to animate from measured height to 0.
 * @param {Element} cartItem - The .cart-item element to animate
 * @param {() => void} [callback] - Called after the element is removed
 */
const animateRowRemoval = (cartItem, callback) => {
  const wrapper = cartItem.closest('[data-cart-line-wrapper]') ?? cartItem;

  if (prefersReducedMotion()) {
    wrapper.remove();
    callback?.();
    return;
  }

  const height = cartItem.offsetHeight;
  cartItem.classList.add('is-removing', 'overflow-hidden');

  const animation = cartItem.animate(
    [
      { height: `${height}px`, opacity: 1 },
      { height: '0px', opacity: 0 },
    ],
    { duration: 300, easing: 'ease' }
  );

  animation.finished.then(() => {
    wrapper.remove();
    callback?.();
  });
};

/**
 * Remove shimmer attribute from all shimmering elements in a container.
 * @param {Element} [container]
 */
const resetShimmer = (container = document.body) => {
  for (const el of container.querySelectorAll('[shimmer]')) {
    el.removeAttribute('shimmer');
  }
};

/**
 * Custom element that wraps price text and supports shimmer animation.
 * Usage in Liquid: <text-component value="₹1,999">₹1,999</text-component>
 * JS triggers shimmer: element.shimmer()
 * Morph auto-clears shimmer by removing the attribute when updating.
 */
class TextComponent extends HTMLElement {
  shimmer() {
    this.setAttribute('shimmer', '');
  }
}

if (!customElements.get('text-component')) {
  customElements.define('text-component', TextComponent);
}
